const UPDATE_SUBSCRIPTIONS = 'UPDATE_SUBSCRIPTIONS';
const UNSUBSCRIBE_AUTOREPLENISHMENT = 'UNSUBSCRIBE_AUTOREPLENISHMENT';
const LOAD_SHIPPING_AND_PAYMENT_INFO = 'LOAD_SHIPPING_AND_PAYMENT_INFO';
const LOAD_CREDIT_CARD_LIST = 'LOAD_CREDIT_CARD_LIST';
const UPDATE_AUTOREPLENISHMENT_SUBSCRIPTION = 'UPDATE_AUTOREPLENISHMENT_SUBSCRIPTION';
const CLEAR_SUBSCRIPTIONS = 'CLEAR_SUBSCRIPTIONS';
const LOAD_COUNTRIES = 'LOAD_COUNTRIES';

export {
    UPDATE_SUBSCRIPTIONS,
    UNSUBSCRIBE_AUTOREPLENISHMENT,
    LOAD_SHIPPING_AND_PAYMENT_INFO,
    LOAD_CREDIT_CARD_LIST,
    UPDATE_AUTOREPLENISHMENT_SUBSCRIPTION,
    CLEAR_SUBSCRIPTIONS,
    LOAD_COUNTRIES
};
